import React from 'react';

export default class About extends React.Component {
    render() {
        const packageJson = require("../../package.json");
        const appVersion = packageJson.version;
        //const appVersion = process.env.npm_package_version;
        return (
            <div>
                <h1>About</h1>
                <p className="gap">Product: HCS Portal</p>
                <p>Version: {appVersion}</p>
                <p>Description: The HCS Portal is a secure, web-based application for clinical research services and operational support.</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/About.js